<template>
  <Container class="relative my-20 flex items-center justify-center overflow-hidden">
    <div
      class="absolute px-16 text-center text-4xl leading-tight text-gray-100 lg:text-5xl"
      v-html="copy" />
    <div class="">
      <SvgLocationMap
        class="absolute h-full"
        preserveAspectRatio="xMidYMid meet" />
      <NuxtImg
        :src="`${cdnUrl}/assets/world.png`"
        alt="Dotted World map graphic"
        class="w-[150vw] max-w-none object-contain lg:w-auto lg:max-w-full"
        sizes="xs:150vw sm:150vw md:150vw lg:1140px xl:1140px xxl:1140px"
        loading="lazy" />
    </div>
  </Container>
</template>

<script setup lang="ts">
  type LocationMap = {
    copy: string
  }

  defineProps<LocationMap>()

  const { cdnUrl } = useRuntimeConfig().public
</script>
